import { MAX_ALWAYS_DOCUMENTS } from '../config/constants';
import {
  DocumentInclusion,
  DocumentType,
  EncounterSchema,
} from '../config/types';

import { isProtocolTemplate } from './documentTypeRules';
import { normalizeInclusionValue } from './normalizeInclusionValue';

export type InclusionChangeError =
  | 'protocol_cannot_be_always'
  | 'too_many_always';

type GetInclusionChangeErrorParams = {
  nextInclusion: DocumentInclusion;
  schema: EncounterSchema;
  documentType?: DocumentType;
  templateSeriesId?: string;
};

export const getInclusionChangeError = ({
  nextInclusion,
  schema,
  documentType,
  templateSeriesId,
}: GetInclusionChangeErrorParams): InclusionChangeError | null => {
  if (nextInclusion !== 'always') {
    return null;
  }

  if (isProtocolTemplate(documentType)) {
    return 'protocol_cannot_be_always';
  }

  const alwaysCount = schema.documents.filter((documentRef) => {
    const isOwnRef =
      Boolean(templateSeriesId) &&
      documentRef.template_series_id === templateSeriesId;

    return (
      !isOwnRef && normalizeInclusionValue(documentRef.inclusion) === 'always'
    );
  }).length;

  if (alwaysCount >= MAX_ALWAYS_DOCUMENTS) {
    return 'too_many_always';
  }

  return null;
};
